import Spinner from '@/components/Spinner';
import { useMediaQuery } from '@/hooks';

import PlanCard from './PlanCard/PlanCard';
import PlansFeatures from './PlansFeatures/PlansFeatures';
import PlansFeaturesMobile from './PlansFeatures/PlansFeaturesMobile';

function Plans({ plansData }) {
	const { plans, bestPlan, loading } = plansData;
	const mdDown = useMediaQuery('mdDown');

	return (
		<>
			<div className="relative flex min-h-[15rem] flex-col md:flex-row md:gap-6">
				{loading && (
					<Spinner
						className="absolute inset-0 m-auto text-grey-500"
						size={24}
					/>
				)}
				{plans.map(plan => {
					const currentPlan = {
						...plan,
						isBestPlan: plan.handlerId === bestPlan.handlerId
					};

					return <PlanCard key={plan.handlerId} plan={currentPlan} />;
				})}
			</div>
			{mdDown ? (
				<PlansFeaturesMobile plans={plans} bestPlan={bestPlan} />
			) : (
				<PlansFeatures plans={plans} />
			)}
		</>
	);
}

export default Plans;
